import { render, staticRenderFns } from "./AddressesDashboard.vue?vue&type=template&id=0389d647&scoped=true&"
import script from "./AddressesDashboard.vue?vue&type=script&lang=js&"
export * from "./AddressesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0389d647",
  null
  
)

export default component.exports